import { axiosPublic } from "../api/axiosCustom";

class ConfigAPIs {
  // Public, no session needed; values are hardcoded on the backend.
  static async getConfig() {
    const response = await axiosPublic.get(`/api/v1/config/`);
    return { response };
  }
}

export default ConfigAPIs;
